<app-health-grid [gridType]="gridType" (searchTermChanged)="onSearchChanged($event)" [title]="title"
                 [total]="total" [totalTitle]="totalTitle">
  <app-fabrics-health-list [widgetClass]="'grid-widget'" (total)="total = $event"
                           [searchText]="searchTerm">
  </app-fabrics-health-list>
</app-health-grid>
